var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
var InfoIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("path", { d: "M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M12,9.69235474 C11.2406085,9.69235474 10.625,10.3079632 10.625,11.0673547 L10.625,11.0673547 L10.625,17.4672019 C10.625,18.2265934 11.2406085,18.8422019 12,18.8422019 C12.7593915,18.8422019 13.375,18.2265934 13.375,17.4672019 L13.375,17.4672019 L13.375,11.0673547 C13.375,10.3079632 12.7593915,9.69235474 12,9.69235474 Z M12,5.11743119 C11.2406085,5.11743119 10.625,5.7319101 10.625,6.48990826 C10.625,7.24790641 11.2406085,7.86238532 12,7.86238532 C12.7593915,7.86238532 13.375,7.24790641 13.375,6.48990826 C13.375,5.7319101 12.7593915,5.11743119 12,5.11743119 Z" }))); };
export default InfoIcon;
